<template>
  <div class="pfixed custome">
<!--    <router-link to="/sign" target="_blank">-->
      <img src="../assets/images/index_09.png" alt="" width="122">
<!--    </router-link>-->
  </div>
</template>

<script>
export default {
  name: "Custome"
}
</script>

<style scoped>
  .custome{right: 20px;top: 40%;z-index: 1026;}
</style>



// WEBPACK FOOTER //
// src/components/Custome.vue